import { formatImageUrl } from '../media_util.js';
import React from 'react';
import styles from './header.module.scss';

function Header({iconUrl, account_name}) {
    return (
        <header className={styles.header}>
            <img
                src={formatImageUrl(iconUrl, 200)}
                alt={''}
                className={styles.icon} />
            <h1>{account_name}</h1>
        </header>
    );
}

export default Header;
